module.exports = __webpack_public_path__ + "img/go_icon.47a5b58d.png";